export const incidentCodigoOptions = {
  1: [
    { id: 1, name: "(MSAW) FALTANTE DOCS" },
    { id: 2, name: "(FSAW) SOBRANTE DOCUMENTOS" },
    { id: 3, name: "DOCUMENTOS NO LOCALIZADOS" },
    { id: 4, name: "INFORMACIÓN OBLIGATORIA" },
    { id: 5, name: "RECHAZO-MERCANCIA NO DECLARADA" },
    { id: 6, name: "SIN PREALERTA SAT" },
    { id: 7, name: "DISCREPANCIA DOCS/CARGA/SISTEMA" }
  ],
  2: [
    { id: 9, name: "(MSCA) FALTANTE CARGA" },
    { id: 10, name: "(FDCA) SOBRANTE CARGA" },
    { id: 11, name: "(OVCD) SOBREVOLADO" },
    { id: 12, name: "SIN IDENTIFICACIÓN" },
    { id: 13, name: "PUNTOS TÁCTICOS" },
    { id: 14, name: "EMPAQUE/CONTENIDO" },
    { id: 24, name: "DESTRUCCIÓN" },
    { id: 25, name: "OMISIÓN OPERATIVA" }
  ],
  3: [
    { id: 16, name: "CCA EXTEMPOR\u00c1NEO" },
    { id: 17, name: "SIN DEP" },
    { id: 18, name: "VUCEM" },
    { id: 26, name: "CCA" }
  ],
  4: [
    { id: 20, name: "LOGISTICA" },
    { id: 21, name: "RESERVA" },
  ]
};

export const incidentIncidenciaOptions = {
  1: [ // Para código con id 1 (FALTANTE DOCS)
    { id: 1, name: "MAWB", incident_responsable_id: 1 },
    { id: 2, name: "HAWB", incident_responsable_id: 1 },
    { id: 3, name: "SET COMPLETO", incident_responsable_id: 1 },
    { id: 4, name: "CHECK LIST DG | RH", incident_responsable_id: 1 },
    { id: 5, name: "DGD", incident_responsable_id: 1 },
    { id: 7, name: "CARTAS DE SEGURIDAD", incident_responsable_id: 1 },
    { id: 77, name: "FITOSANITARIO", incident_responsable_id: 1 },
    { id: 78, name: "CARTA DISCLAIMER", incident_responsable_id: 1 },
    { id: 79, name: "DOCUMENTOS DE RESTOS HUMANOS", incident_responsable_id: 1 },
    { id: 80, name: "ORIGINAL Y/O COPIAS", incident_responsable_id: 1 },
    { id: 81, name: "DECLARACION DE SEGURIDAD", incident_responsable_id: 1 }
  ],
  2: [ // Para código con id 2 ((FSAW) SOBRANTE DOCUMENTOS)
    { id: 8, name: "MAWB", incident_responsable_id: 1 },
  ],
  3: [ // Para código con id 3 ((FSAW) SOBRANTE DOCUMENTOS)
    { id: 82, name: "NO LOCALIZADOS - VUELO COMPLETO", incident_responsable_id: 3 },
    { id: 83, name: "NO LOCALIZADOS - EMBARQUE", incident_responsable_id: 3 },
  ],
  4: [
    { id: 11, name: "HS/HCC", incident_responsable_id: 4 },
    { id: 12, name: "CUIT", incident_responsable_id: 4 },
    { id: 13, name: "RUC", incident_responsable_id: 4 },
    { id: 14, name: "EMAIL", incident_responsable_id: 4 },
    { id: 15, name: "TELÉFONO CNNE", incident_responsable_id: 4 },
    { id: 84, name: "HS6", incident_responsable_id: 4 },
    { id: 85, name: "EORI", incident_responsable_id: 4 },
    { id: 86, name: "RUC", incident_responsable_id: 4 },
    { id: 87, name: "DIRECCIÓN INCOMPLETA", incident_responsable_id: 4 },
    { id: 88, name: "TAX ID", incident_responsable_id: 4 },
    { id: 89, name: "DESCRIPCIÓN EN INGLÉS", incident_responsable_id: 4 },
    { id: 90, name: "CARTA DE SEGURIDAD DECLARA DATOS INCORRECTOS/INCOMPLETOS", incident_responsable_id: 4 },
    { id: 91, name: "DGD NO CUMPLE REQUISITOS", incident_responsable_id: 4 },
    { id: 92, name: "NO DECLARA BATERIAS ION LITIO SECC. II", incident_responsable_id: 4 }
  ],
  5: [
    { id: 19, name: "RECHAZO POR CARGA RESTRINGIDA", incident_responsable_id: 4 }
  ],
  6: [
    { id: 20, name: "DEMORA EN EL INGRESO", incident_responsable_id: 7 }
  ],
  7: [
    { id: 21, name: "PIEZAS", incident_responsable_id: 4 },
    { id: 22, name: "KILOS", incident_responsable_id: 4 },
    { id: 23, name: "DESTINO", incident_responsable_id: 4 },
    { id: 24, name: "REMITENTE", incident_responsable_id: 4 },
    { id: 25, name: "CONSIGNATARIO", incident_responsable_id: 4 },
    { id: 26, name: "TEMPERATURA", incident_responsable_id: 4 },
    { id: 27, name: "VARIACIÓN DE PESO", incident_responsable_id: 4 },
    { id: 93, name: "DIMENSIONES", incident_responsable_id: 4 },
    { id: 94, name: "DESCRIPCIÓN", incident_responsable_id: 4 },
    { id: 95, name: "TACHADURAS/ENMENDADURAS A MANO", incident_responsable_id: 4 },
    { id: 96, name: "INCONSISTENCIA EN RANGO DE TEMPERATURA", incident_responsable_id: 4 },
    { id: 97, name: "MÁS PIEZAS/PESO QUE EN LA RESERVA", incident_responsable_id: 4 },
    { id: 98, name: "MENOS PIEZAS/PESO QUE EN LA RESERVA", incident_responsable_id: 4 },
    { id: 99, name: "PIEZAS SIN ETIQUETA", incident_responsable_id: 4 },
    { id: 100, name: "DISCREPANCIA EN + DE DOS DOCUMENTOS", incident_responsable_id: 4 },
    { id: 101, name: "TRASFERENCIA MAL ELABORADA", incident_responsable_id: 4 },
    { id: 102, name: "CONSOLIDADA SIN MANIFIESTO/HAWB", incident_responsable_id: 4 },
    { id: 103, name: "MANIFIESTO HAWB ERRÓNEO", incident_responsable_id: 4 },
    { id: 104, name: "HAWB CON DATOS DIFERENTES A MAWB", incident_responsable_id: 4 },
    { id: 105, name: "DGR NO CUMPLE CON LO INDICADO EN GUÍA", incident_responsable_id: 4 },
    { id: 106, name: "DGR NO COINCIDE CON MASTER Y HOUSE", incident_responsable_id: 4 },
    { id: 107, name: "PHARMA SIN DISCLAIMER", incident_responsable_id: 4 },
    { id: 108, name: "PHARMA NO CUMPLE", incident_responsable_id: 4 }
  ],
  9: [
    { id: 34, name: "FT (FALTANTE TOTAL)", incident_responsable_id: 1 },
    { id: 35, name: "FP (FALTANTE PARCIAL)", incident_responsable_id: 1 }
  ],
  10: [
    { id: 36, name: "NO MANIFESTADA-CORRESPONDE AL DESTINO", incident_responsable_id: 1 }
  ],
  11: [
    { id: 37, name: "NO MANIFESTADA-NO CORRESPONDE AL DESTINO", incident_responsable_id: 1 }
  ],
  12: [
    { id: 38, name: "PIEZAS SIN ETIQUETA", incident_responsable_id: 1 }
  ],
  13: [
    { id: 39, name: "DETENIDA-PIERDE CONEXI\u00d3N", incident_responsable_id: 5 },
    { id: 40, name: "DETENIDA-PENDIENTE LIBERACI\u00d3N", incident_responsable_id: 5 },
    { id: 109, name: "PAMA", incident_responsable_id: 5 }
  ],
  14: [
    { id: 114, name: "ROTO", incident_responsable_id: 10 },
    { id: 115, name: "SIN FLEJE", incident_responsable_id: 10 },
    { id: 116, name: "CONTENIDO EXPUESTO", incident_responsable_id: 10 },
    { id: 117, name: "APLASTADO", incident_responsable_id: 10 },
    { id: 118, name: "MOJADO/HUMEDO", incident_responsable_id: 10 },
    { id: 119, name: "CINTA ADHESIVA DIFERENTE", incident_responsable_id: 10 },
    { id: 120, name: "TARIMA ROTA", incident_responsable_id: 10 },
    { id: 121, name: "PICADO | UÑAZO", incident_responsable_id: 10 },
    { id: 122, name: "SIN CONTENIDO", incident_responsable_id: 10 },
    { id: 123, name: "DERRAME", incident_responsable_id: 10 }
  ],
  24: [
    { id: 130, name: "REPROGRAMACI\u00d3N CONTINUA", incident_responsable_id: 11 },
    { id: 131, name: "FALTA DE PROGRAMACI\u00d3N", incident_responsable_id: 12 },
    { id: 132, name: "DOCUMENTOS NO CUMPLEN PARA EL DESTINO", incident_responsable_id: 13 },
    { id: 133, name: "CLIENTE SOLICITA DESDE LA PRIMERA REPROGRAMACI\u00d3N", incident_responsable_id: 13 },
  ],
  25: [
    { id: 134, name: "SIN TRANSFERENCIA EN TIEMPO", incident_responsable_id: 14 },
    { id: 135, name: "ALMAC\u00c9N DESTINO FUERA DE HORARIO", incident_responsable_id: 15 },
    { id: 136, name: "SIN NOTIFICACI\u00d3N DE CUT OFF", incident_responsable_id: 16 },
    { id: 137, name: "CARGA EN BKD/RCS EN ORIGEN", incident_responsable_id: 17 },
  ],
  16: [
    { id: 67, name: "MAYOR A 48h", incident_responsable_id: 6 },
    { id: 68, name: "CARGA SALI\u00d3 ANTES DE SOLIC. CCA", incident_responsable_id: 6 },
  ],
  17: [
    { id: 124, name: "CARGA EN BKD, SIN TRANSMISION A HORUS/VUCEM", incident_responsable_id: 1 },
    { id: 125, name: "CARGA EN RCS, SIN TRANSMISION A HORUS/VUCEM", incident_responsable_id: 1 },
    { id: 126, name: "CARGA EN MAN, SIN TRANSMISION A HORUS/VUCEM", incident_responsable_id: 1 },
    { id: 127, name: "CARGA SIN TRANSMISI\u00d3N A VUCEM", incident_responsable_id: 1 }
  ],
  18: [
    { id: 70, name: "CARGA SIN TRANSMISI\u00d3N", incident_responsable_id: 1 },
  ],
  26: [
    { id: 138, name: "DESTINO INCORRECTO", incident_responsable_id: 6 },
    { id: 139, name: "CONSIGNATARIO", incident_responsable_id: 6 },
    { id: 140, name: "DIMENSIONES", incident_responsable_id: 6 },
    { id: 141, name: "KILOS", incident_responsable_id: 6 },
    { id: 142, name: "EXTEMPORÁNEO (MAYOR A 48h)", incident_responsable_id: 6 },
    { id: 143, name: "CARGA SALIÓ ANTES DE SOLIC. CCA", incident_responsable_id: 6 }
  ],
  20: [
    { id: 128, name: "SIN RESERVACI\u00d3N SEGUNDO TRAMO", incident_responsable_id: 6 },
    { id: 129, name: "RESERVA VENCIDA", incident_responsable_id: 6 },
  ],
  21: [
    { id: 74, name: "DESTINO INCORRECTO", incident_responsable_id: 6 },
    { id: 75, name: "CONSIGNATARIO", incident_responsable_id: 6 },
  ]
};

export const allResponsables = [
  { id: 1, name: 'GHA' },
  { id: 2, name: 'ORIGEN' },
  { id: 3, name: 'PLATAFORMA' },
  { id: 4, name: 'GSA/GHA' },
  { id: 5, name: 'AUTORIDAD' },
  { id: 6, name: 'GSA' },
  { id: 7, name: 'GHA/ESTACIÓN NACIONAL/INTERLINEAL/OPT' },
  { id: 8, name: 'PLATAFORMA/INTERLINEALES' },
  { id: 9, name: 'ORIGEN/PLATAFORMA/ALMACÉN' },
  { id: 10, name: 'ALMACÉN/GHA/PLATAFORMA/ESTACIÓN NACIONAL/INTERLINEAL/OPT' },
  { id: 11, name: 'CAPACIDADES/LOGISTICA/ALMACÉN/INTERLINEAL/OPT' },
  { id: 12, name: 'LOGISTICA/ALMACÉN' },
  { id: 13, name: 'CLIENTE' },
  { id: 14, name: 'ALMACEN' },
  { id: 15, name: 'INTERLINEAL' },
  { id: 16, name: 'GHA/LOGISTICA' },
  { id: 17, name: 'GHA/ESTACIÓN NACIONAL/INTERLINEAL/OPT' },
  { id: 18, name: 'SISTEMAS' },
  { id: 19, name: 'RESERVACIONES' }
];